import { differenceInYears } from "date-fns";
import { now } from "./now";
import { parseDate } from "./parseDate";

export const computeAge = (birthday: string | Date | null | undefined) => {
  if (!birthday) return 0;
  const birthDate = parseDate(birthday);
  const age = differenceInYears(now(), birthDate);
  return age;
};
